<template>
	<el-menu  active-text-color="#ffd04b" background-color="rgb(48, 65, 86)" text-color="#fff" default-active="2"
		class="el-menu-vertical-demo" :collapse="isCollapse" @open="handleOpen" @close="handleClose" router>
		<!-- <div class="title">后台管理系统</div> -->
		<template v-for="subItem in menus" :key="subItem.path">

			<!-- 两层 -->
			<el-sub-menu v-if="subItem.alwaysShow" :index="subItem.path">

          <template #title >
            <el-icon>
              <component :is="subItem.meta.icon"></component>
            </el-icon>
            <span>{{ subItem.meta.title }}</span>
          </template>

          <template v-for="item in subItem.children" :key="item.path">

            <el-menu-item :index="item.path" v-if="item.alwaysShow">
              <el-icon>
                <component :is="item.meta.icon"></component>
              </el-icon>
              <template #title>
                <span>{{ item.meta.title }}</span>
              </template>
            </el-menu-item>
            
          </template>

			</el-sub-menu>

			

		</template>
 
	</el-menu>
</template>
 
<script setup>
	import { computed, ref } from 'vue'
	import { useRouter } from 'vue-router'
	const router = useRouter();
	const top = ref(true)
	const menus = computed(() => {
		let menu = router.options.routes.filter((item) => item.children);
		return menu[0].children
	})

  //console.log(123,menus)
	//import { layoutStore } from '@/store/layout.js'
	//const store = layoutStore();
	// const isCollapse = ref(false)
	const isCollapse = computed(() => {
		//return store.isCollapse;
	})
	const handleOpen = (key  , keyPath ) => {
        // console.log("---handleOpen--")
		// console.log(key, keyPath)
	}
	const handleClose = (key , keyPath ) => {
        // console.log("---handleClose--")
		// console.log(key, keyPath)
	}
</script>
 
<style>
	.el-menu-vertical-demo {
		width: 210px;
		min-height: 400px;
	}
 
	.el-menu {
		border-right: 0;
	}
 
	.title {
		font-size: 18px;
		display: flex;
		justify-content: center;
		top: 5px;
		margin-top: 15px;
	}
</style>